import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import { AssetFilter, AssetRecentlyAdded } from 'models'
import { ClickableStatCard, StatSkeletonBar } from './statCard.styles'

interface Props {
  icon: JSX.Element
  recentlyAdded: AssetRecentlyAdded | null
  loading: boolean
  onApplyFilter: (filter: AssetFilter) => void
}

const RecentlyAddedCard: FC<Props> = ({ icon, recentlyAdded, loading, onApplyFilter }) => (
  <ClickableStatCard>
    <Box
      component="button"
      type="button"
      className="stat-action"
      disabled={loading || !recentlyAdded?.filter}
      aria-label={
        recentlyAdded
          ? `Filter the grid to ${recentlyAdded.count} entities added in the last ${recentlyAdded.days} days`
          : 'Recently added'
      }
      onClick={() => recentlyAdded?.filter && onApplyFilter(recentlyAdded.filter)}
    >
      <Box className="stat-header">
        <Box className="stat-heading">
          <Box className="stat-icon">{icon}</Box>
          <Typography className="stat-title">Recently added</Typography>
        </Box>
      </Box>
      <Box className="stat-body">
        {loading || !recentlyAdded ? (
          <StatSkeletonBar />
        ) : (
          <>
            <Typography component="span" className="stat-value">
              {recentlyAdded.count.toLocaleString()}
            </Typography>
            <Typography component="span" className="stat-sublabel">
              since last month
            </Typography>
          </>
        )}
      </Box>
    </Box>
  </ClickableStatCard>
)

export default RecentlyAddedCard
